import React from 'react';

interface SendIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const SendIcon = (props: SendIconProps) => {
  const { className = '', ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      className={className}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.88389 0.745019C8.39574 0.256869 7.60428 0.256869 7.11613 0.745019L0.774607 7.08654L0.111694 7.74946L1.43752 9.07528L2.10043 8.41237L7.06252 3.45028V16.812V17.7495H8.93752V16.812V3.45028L13.8996 8.41237L14.5625 9.07528L15.8884 7.74946L15.2254 7.08654L8.88389 0.745019Z"
        fill="currentColor"
        fillOpacity="1"
      />
    </svg>
  );
};

export default SendIcon;
